<template>
    <v-card>
        <v-card-title class="text-subtitle-1">Today's functions</v-card-title>
        <v-table v-if="functions.length > 0" density="comfortable" class="pavo-functions-table">
            <thead>
                <tr>
                    <th>Time</th>
                    <th>Function</th>
                    <th>Room</th>
                    <th>Conference</th>
                    <th class="text-right">Set / Act</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in functions" :key="item.id">
                    <td class="pavo-mono">{{ formatTimeRange(item.begin, item.end) }}</td>
                    <td>{{ item.name }}</td>
                    <td>{{ item.room }}</td>
                    <td>
                        <v-chip
                            v-if="item.conferenceCode"
                            size="small"
                            color="primary"
                            variant="tonal"
                        >
                            {{ item.conferenceCode }}
                        </v-chip>
                    </td>
                    <td class="text-right pavo-mono">
                        {{ item.roomSet ?? "-" }} / {{ item.actual ?? "-" }}
                    </td>
                </tr>
            </tbody>
        </v-table>
        <v-card-text v-else class="text-medium-emphasis">
            No functions scheduled today.
        </v-card-text>
    </v-card>
</template>

<script setup lang="ts">
import type { DashboardFunction } from "@a/dashboard";
import { formatTimeRange } from "./format";

type Props = {
    functions: DashboardFunction[];
};

defineProps<Props>();
</script>

<style lang="scss">
.pavo-mono {
    font-family: "Roboto Mono", monospace;
    font-variant-numeric: tabular-nums;
    font-size: 13px;
}
</style>
